"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJsonClusterFeatureLoader = void 0;
var olExtent = require("ol/extent");
var GeoJSON_1 = require("ol/format/GeoJSON");
var GeoJsonClusterFeatureLoader = /** @class */ (function () {
    function GeoJsonClusterFeatureLoader() {
        this.load = function (layerSource, featureAdd, data, dataProjection, displayProjection, resolution, logger, wktProperty) {
            if (wktProperty === void 0) { wktProperty = null; }
            //remove existing features       
            layerSource.source.clear(true);
            var format = new GeoJSON_1.default();
            var dataBounds = olExtent.createEmpty();
            var features = format.readFeatures(data, {
                dataProjection: dataProjection,
                featureProjection: displayProjection
            });
            layerSource.source.getSource().addFeatures(features);
            layerSource.source.forEachFeature(function (feature) {
                dataBounds = olExtent.extend(dataBounds, feature.getGeometry().getExtent());
            });
            return dataBounds;
        };
    }
    return GeoJsonClusterFeatureLoader;
}());
exports.GeoJsonClusterFeatureLoader = GeoJsonClusterFeatureLoader;
//# sourceMappingURL=GeoJsonClusterFeatureLoader.js.map